import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';
import { tannerBlack, tannerSemantic, tannerWhite } from '../colors';

type MuiPaper = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiPaper'];
  defaultProps?: ComponentsProps['MuiPaper'];
  variants?: ComponentsVariants['MuiPaper'];
};

export const MuiPaper: MuiPaper = {
  styleOverrides: {
    root: {
      '& .MuiPickersCalendarHeader-labelContainer': {
        overflow: 'visible',
      },
      '& .MuiPickersYear-yearButton.Mui-selected:focus-visible': {
        backgroundColor: tannerBlack,
        color: tannerWhite,
      },
      '& .MuiYearPicker-root': {
        '& .PrivatePickersYear-root': {
          '& .PrivatePickersYear-yearButton': {
            '&:focus, &:focus-visible': {
              outline: `3px solid ${tannerSemantic.info.color}`,
              outlineOffset: 3,
            },
          },
        },
      },
    },
  },
};
